export default __webpack_public_path__ + "static/media/guesty_lite_step1.76144138.png";